<template>
  <div id="payment">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'payment'
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/financial/payment/Payment.vue